import {
  Box,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Text,
  Stack,
  Button,
  HStack,
  SimpleGrid,
  Editable,
  EditablePreview,
  EditableTextarea,
  Flex,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deletePost, getChannelsPosts } from "../redux/posts/post.action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AltNavbar from "../components/AltNavbar";
import SideBar from "../components/SideBar";

const InstagramPage = () => {
  const { data, loading, error } = useSelector((store) => store.posts);
  const dispatch = useDispatch();
  const [editDate, setEditDate] = useState({});
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    dispatch(getChannelsPosts("instagram_posts"));
  }, []);

  const handleDelete = (_id) => {
    dispatch(deletePost(_id, "instagram_posts"));
    // dispatch(getChannelsPosts("facebook_posts"));
  };

  if (loading) {
    return (
      <Box w="100%" mt="300px">
        <Spinner
          thickness="8px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Box>
    );
  }

  return (
    <>
      <AltNavbar />
      <Flex justifyContent="space-between">
        <SideBar />
        {data.length === 0 ? (
          <Box
            w="82.5%"
            bgImage="./empty.jpg"
            bgPosition="cover"
            bgRepeat="no-repeat"
            mt={10}
          ></Box>
        ) : (
          <Box w="82.5%">
            <SimpleGrid
              spacing={4}
              mt={5}
              textAlign="left"
              templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
            >
              {data?.map((el) => (
                <Card key={el.start + Date.now()}>
                  <CardHeader>
                    <Heading size="md">
                      {/* {el.end.split("T")[0]} */}
                      {/* <Editable defaultValue={el.end.split("T")[0]}>
                        <EditablePreview />
                        <EditableTextarea
                          onChange={(e) => setEditDate(e.target.value)}
                        />
                      </Editable> */}
                      <DatePicker
                        placeholderText={el.end.split("T")[0]}
                        value={el.end.split("T")[0]}
                        selected={el.end}
                        onChange={(start) => setEditDate({ start, end: start })}
                      />
                    </Heading>
                  </CardHeader>
                  <CardBody>
                    <Editable defaultValue={el.title}>
                      <EditablePreview />
                      <EditableTextarea />
                    </Editable>
                  </CardBody>
                  {/* <CardBody>
                    <Text>{el.title}.</Text>
                  </CardBody> */}
                  <CardFooter gap={5}>
                    <Button w={20} colorScheme="blue">
                      Edit
                    </Button>
                    <Button
                      w={20}
                      colorScheme="red"
                      onClick={() => handleDelete(el._id)}
                    >
                      Delete
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </SimpleGrid>
          </Box>
        )}
      </Flex>
    </>
  );
};

export default InstagramPage;
